import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/app/src/features/Footer/Footer.tsx");
import(/* webpackMode: "eager" */ "/app/src/features/Header/Header.tsx");
import(/* webpackMode: "eager" */ "/app/src/providers/Providers.tsx");
import(/* webpackMode: "eager" */ "/app/src/styles/Provider.tsx")